export default __webpack_public_path__ + "static/media/guillaume-2.abb8f903.png";